import { useQuery } from '@tanstack/react-query';
import productReviewsService from '../../../services/productReviews';
import {
  PiiEncryptionKeyResponse,
  PiiEncryptionKey,
} from '../../../utils/productReviews/types';

/**
 * Fetch Bazaarvoice PII public encryption key data from Drupal.
 */
const useGetPiiEncryptionKey = (enabled = true) =>
  useQuery({
    queryKey: ['useGetPiiEncryptionKey'],
    enabled,
    queryFn: async (): Promise<PiiEncryptionKey> => {
      const piiEncryptionKeyResponse: PiiEncryptionKeyResponse =
        await productReviewsService.getPiiEncryptionKey();

      return piiEncryptionKeyResponse.data.attributes.data;
    },
  });

export default useGetPiiEncryptionKey;
